module.exports = "<h3 class=\"sharecount__heading\"><%=icon%><span class=\"sharecount__text u-h\">Shares</span></h3>\n<div class=\"sharecount__value sharecount__value--full\">0</div>\n<div class=\"sharecount__value sharecount__value--short\">0</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/content/share-count.html
// module id = 711
// module chunks = 2